const ManagedCard = ({ fill = '#fff' }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.6 6H6.4C5.068 6 4.012 7.068 4.012 8.4L4 22.8C4 24.132 5.068 25.2 6.4 25.2H25.6C26.932 25.2 28 24.132 28 22.8V8.4C28 7.068 26.932 6 25.6 6ZM25.6 22.8H6.4V15.6H25.6V22.8ZM25.6 10.8H6.4V8.4H25.6V10.8Z"
        fill={fill}
      />
    </svg>
  );
};
export default ManagedCard;
